import React from 'react';

import { Icon } from '@chakra-ui/react';

export const TriangleDownIcon = props => (
  <Icon viewBox="0 0 20 20" color="inherit" h="full" w="full" {...props}>
    <path d="M5 6h10l-5 9-5-9z" />
  </Icon>
);
